<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX1+PTTx8g0tEgDQTNfFjdak9otu3U9D0wLI=","cpf":"U2FsdGVkX1/CS1W/vWH8P5i40DSK07ioF7GpdLZM6rA="},{"num_cand":"U2FsdGVkX18zCIF/S9wRtNoEnarQaGIHov1sE4baBk8=","cpf":"U2FsdGVkX1+SPy+rG851x4g9+tUg8RYEr5cXG3Jp/z4="},{"num_cand":"U2FsdGVkX18gxg0N7Imm5SHV4rz9UcjTWV6NY6CWuo0=","cpf":"U2FsdGVkX1+USr/sSsn/ei9qzLnRGAEbOywpa+iC8g8="},{"num_cand":"U2FsdGVkX18UdYV0mwQEZXXCTDuQDdcUvfq/0wns9dw=","cpf":"U2FsdGVkX1/9WPscdSll4NyQ6NIy4lpek3SA6Nywbi8="},{"num_cand":"U2FsdGVkX19sm80CMBnfVHEYGdtLXfu823bWFX9AjhY=","cpf":"U2FsdGVkX18HuPWk5bn2NYZtaIQzO9xBrmusOn/lY9M="},{"num_cand":"U2FsdGVkX19AIyBb8jED2gPRv9GkOgEwlJ/Pnw6h+8o=","cpf":"U2FsdGVkX19fzb+RXLPrnjDSpxKmtx/XgJGSv4Sx4kI="},{"num_cand":"U2FsdGVkX1895pBhKMcmHjaqecjqt6+0yfKYqZrdu+0=","cpf":"U2FsdGVkX1+OyjPUDgbTT2A3QHRmxzDc8Nc8lQeLAWc="},{"num_cand":"U2FsdGVkX1/byiUVglfFtT/jXo9Cllj0Ps47l46Tq3o=","cpf":"U2FsdGVkX19zR5ve/v9ErviaMYwhA8vkAWfhnKy/Wlw="},{"num_cand":"U2FsdGVkX19uIOS6uVNajasZlMrq5nwlu7+THp5x9PY=","cpf":"U2FsdGVkX1/Rnx4KcvQNLX9oqKO0c6+oqRKM3vYk/A4="},{"num_cand":"U2FsdGVkX19iaYXatFcy5TKrMqf+BsMkG/C4/aHtgCc=","cpf":"U2FsdGVkX1/Eu9x1IcwgMjNcOzQaj1o5EWYbs9ngKNc="},{"num_cand":"U2FsdGVkX188fsb3eVHh4IN/DDAB5oj6CuJZB3c9iwc=","cpf":"U2FsdGVkX19r4D3O6e+yBVzqL9l01b2uHLXnKzMWfqg="},{"num_cand":"U2FsdGVkX1/7ah/PQgKihcf3EJKfgcmxOciuy3lkgys=","cpf":"U2FsdGVkX1/eHVAtERS7j2hgeSVG/SaGOZjKSLiYYoo="},{"num_cand":"U2FsdGVkX1/FdZIn+Sbh6+aNdRLOYt7ipqop1KucoKs=","cpf":"U2FsdGVkX1/Lo8UzrPdLAE56e8a5Ep+pDjVI3ioI0NY="},{"num_cand":"U2FsdGVkX1/e/6MSni2ERmt0tZMPzWgdFlXIHjZ6h8Q=","cpf":"U2FsdGVkX1+3kP5bJ6mZ2xTY4qII6Omn1aPWrcFv6aY="},{"num_cand":"U2FsdGVkX19IWXJFhQsyKuf3M+nKXlGbwpp2WwByvH4=","cpf":"U2FsdGVkX18wHRi8jbiR65/O0ST210lc6r4OWWJNCyU="},{"num_cand":"U2FsdGVkX18jEt9pZyfitkhgzNEQNypJM6+1Biq29o8=","cpf":"U2FsdGVkX19TVyEGht9lFUjF934cI3cEQX+ybJguxnk="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2205/res_taf_def/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
